// Client V1 imports
const airbrake = require('client/lib/airbrake')
const { send: ajax } = require('client/lib/request')
// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')

// Action types

const CONTACTS_FAILED = 'SELF_USER_CONTACTS_FAILED'
const CONTACTS_LOADED = 'SELF_USER_CONTACTS_LOADED'
const CONTACTS_LOADING = 'SELF_USER_CONTACTS_LOADING'
const UPDATE = 'SELF_USER_UPDATE'

// Action creators

function update(obj) {
  return {
    type: UPDATE,
    payload: obj
  }
}

// Action dispatchers

function loadContacts() {
  return async function (dispatch, getState) {
    const { user } = getState()
    // Logged-out users don't have contacts; only fetch once
    if (!user.loggedIn || user.contactsState !== FetchStateEnum.EMPTY) {
      return
    }
    dispatch({
      type: CONTACTS_LOADING
    })
    try {
      const contacts = await ajax({
        url: '/api/v0.1/user/contacts',
        method: 'post'
      })
      dispatch({
        type: CONTACTS_LOADED,
        payload: { contacts }
      })
    } catch (err) {
      airbrake.notify(err)
      dispatch({
        type: CONTACTS_FAILED
      })
    }
  }
}

module.exports = {
  CONTACTS_FAILED,
  CONTACTS_LOADED,
  CONTACTS_LOADING,
  UPDATE,
  loadContacts,
  update
}
